require('./hireCardMaestroView.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @actions
const hireCardMaestroActions = require('actions/hireCardMaestro');
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
const preContractualMailActions = require('actions/contactCenter/preContractualMailInfo/preContractualMailInfo');
const profileActions = require('actions/profile');
const shippingAddressAction = require('actions/shippingAddress');
const mergePreContractualsPDF = require('actions/mergePreContractualsPDF');
const precontractualDocumentMailAction = require('actions/precontractualDocumentsMailer');
const termsAndCondsInfoActions = require('actions/termsAndCondsInfo');

// @commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @components
const HireCardMaestroStep1 = require('components/hire/hireCardMaestro/hireCardMaestroStep1/hireCardMaestroStep1');
const HireCardMaestroStep2 = require('components/hire/hireCardMaestro/hireCardMaestroStep2/hireCardMaestroStep2');
const HireCardMaestroStep3 = require('components/hire/hireCardMaestro/hireCardMaestroStep3/hireCardMaestroStep3');
const HireCardMaestroStep4 = require('components/hire/hireCardMaestro/hireCardMaestroStep4/hireCardMaestroStep4');
const HireCardMaestroSuccess = require('components/hire/hireCardMaestro/hireCardMaestroSuccess/hireCardMaestroSuccess');
const HireCardMaestroError = require('components/hire/hireCardMaestro/hireCardMaestroError/hireCardMaestroError');
const HireCardSidebar = require('components/hire/hireCardSidebar/hireCardSidebar');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const InactiveAccountsError = require('components/commons/inactiveAccountsError/inactiveAccountsError');

// @constants
const {
    ACCOUNT_INTERVENTION_CO_OWNER,
    ACCOUNT_INTERVENTION_OWNER,
    ACCOUNT_INTERVENTION_AUTHORIZED,
    CHECKING_ACCOUNT_CODE,
    EURO_TEXT,
    REDIRECT_URL,
    SECOND_STEP,
    WIZARD_FIRST_STEP
} = require('constants/index');

const {
    MAESTRO_TYPE,
    MAESTRO_STANDARD,
    MAESTRO_SUBTYPE,
    MAESTRO_PROCESS_SUBTYPE
} = require('constants/cards');
const { ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES } = require('constants/accounts');
const { R42_TRAVEL_PLUS_OFF_HIRING, ES_COUNTRY, MESSAGE_HIRE_24H } = require('constants/flagBasedFeatures');

class HireCardMaestroView extends React.Component {
    constructor(props) {
        super(props);
        this.isReady = this.isReady.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        const {
            getHireCardImages,
            match: { params: { redirect } },
            validateStep,
            getshippingAddressList,
            resetPrecontractualDocumentMail,
        } = this.props;

        resetPrecontractualDocumentMail();
        getHireCardImages([this.getCardImage()]);

        if (redirect === REDIRECT_URL) {
            validateStep(WIZARD_FIRST_STEP);
        }
        getshippingAddressList();
    }

    componentWillUnmount() {
        const {
            reset,
            resetPrecontractualMail,
            resetTermsAndCondsText,
        } = this.props;

        reset();
        resetTermsAndCondsText();

        if (__CONTACT_CENTER__) {
            resetPrecontractualMail();
        }
    }

    getProcessDetail() {
        return `${MAESTRO_TYPE}.${MAESTRO_PROCESS_SUBTYPE}`;
    }

    getCardImage() {
        const { flagBasedFeatures } = this.props;
        const cardImageIds = {
            default: flagBasedFeatures.get(R42_TRAVEL_PLUS_OFF_HIRING) ? 'B.506.019.007' : 'B.506.019.012',
        }

        return cardImageIds['default'];
    }

    handleCancel() {
        this.props.history.push('/myprofile/cards');
    }

    isReady() { // it warns the user if he's about to lose changes
        const { immHireCardMaestro } = this.props;
        let showPreLeaveModal = true;

        if (immHireCardMaestro.get('visibleStep') === 1) {
            showPreLeaveModal = false;
        }

        return showPreLeaveModal;
    }

    buildSuccessful() {
        const {
            immAccounts,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireCardMaestro,
            immProfile,
            immShippingAddressList
        } = this.props;
        const selectedAccount = immHireCardMaestro.getIn(['steps', SECOND_STEP, 'accountId']);
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);

        const processDetail = this.getProcessDetail();

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <HireCardMaestroSuccess
                    immAccount={immAccount}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCardNameSelector={immHireCardNameSelector}
                    immHireCardMaestro={immHireCardMaestro}
                    immProfile={immProfile}
                    immShippingAddress={immShippingAddressList}
                    originCountry={immProfile.get('originCountry')}
                    processDetail={processDetail}
                />
            </div>
        );
    }

    filterAccounts() {
        const { immAccounts } = this.props;
        const immAcountsWithoutDebitCard = this.getAccountsWithoutDebitCard();
        const interventionTypes = [
            ACCOUNT_INTERVENTION_OWNER,
            ACCOUNT_INTERVENTION_CO_OWNER,
        ];

        if (__CONTACT_CENTER__) {
            const index = interventionTypes.indexOf(ACCOUNT_INTERVENTION_AUTHORIZED);
            if (index > -1) {
                interventionTypes.splice(index, 1);
            }
        }

        const accountsIndexes = immAcountsWithoutDebitCard.filter(accountId =>
            // We remove the accounts that are not in euros
            immAccounts.getIn(['byId', accountId, 'balance', 'currency']) === EURO_TEXT
        ).filter(accountId =>
            // We remove the accounts that don't comply with the requisites of product type and subtype
            immAccounts.getIn(['byId', accountId, 'newProduct']) === String(CHECKING_ACCOUNT_CODE) &&
            ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES.includes(immAccounts.getIn(['byId', accountId, 'accountType']))
        ).filter(accountId =>
            // We remove the accounts where the user is not the owner
            interventionTypes.includes(immAccounts.getIn(['byId', accountId, 'interventionType']))
        );

        // We return an array with the ids of the filtered accounts
        return accountsIndexes.toJS();
    }

    getAccountsWithoutDebitCard() {
        const { immAccounts, immCards } = this.props;
        return immAccounts.get('byOrder').filter(accountId => {
            const accountHasDebit = immCards.getIn(['debit', 'byOrder']).find(cardId => {
                const immCard = immCards.getIn(['byId', cardId]);
                return immCard.get('isMaestro') &&
                    immCard.get('status') === 'EN VIGOR' &&
                    (immCard.get('associatedAccountShort') === immAccounts.getIn(['byId', accountId, 'contractNumber']));
            });

            return !accountHasDebit;
        });
    }

    buildWizardHiringSteps() {
        const {
            flagBasedFeatures,
            gestorCrossEnabled,
            handleAccountChange,
            handleAgreementCheckboxChange,
            hireCardMaestro,
            immAccounts,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireCardMaestro,
            immHireInformation,
            immHiringProductInformation,
            immHireContactData,
            immPreContractualMail,
            immProfile,
            immPdfData,
            immShippingAddressList,
            immContracts,
            isInactiveAccountsEnabled,
            requestPDFMerge,
            requestProfile,
            sendPreContractualMail,
            sendPrecontractualDocumentMail,
            setAllAccountsToInactive,
            setVisibleStep,
            setWillCancel,
            setShippingAddress,
            setTermsAndCondsText,
            validateStep
        } = this.props;
        const wizardActions = {
            cancel: this.handleCancel,
            finish: hireCardMaestro,
            setVisibleStep,
            setWillCancel,
            validateStep
        };
        const showPreLeaveModal = this.isReady();
        const immSteps = immHireCardMaestro.get('steps');
        const sendMailParams = {
            type: MAESTRO_TYPE,
            subType: MAESTRO_SUBTYPE,
            standar: MAESTRO_STANDARD
        };
        let hasShippingAddress = true;

        const tealium = {
            processDetail: this.getProcessDetail()
        }
        const isShippingAddressButtonDisabled = !!immShippingAddressList && !immShippingAddressList.get('shippingAddressType') && flagBasedFeatures.get(ES_COUNTRY);
        const loadingFlag = immHireCardMaestro.get('loadingFlag');

        return (
            <div>
                <div className="col-xs-12 col-md-8">
                    <Wizard
                        actions={wizardActions}
                        immSteps={immSteps}
                        showPreLeaveModal={showPreLeaveModal}
                        stepsAmount={immSteps.size}
                        tealium={tealium}
                        visibleStep={immHireCardMaestro.get('visibleStep')}
                        wizardClass="hire-card-maestro__wizard"
                    >
                        <WizardStep
                            cancelButton={true}
                            position="first"
                            isLoading={loadingFlag}
                        >
                            <WebappRender>
                                <HireCardMaestroStep1
                                    flagBasedFeatures={flagBasedFeatures}
                                    gestorCrossEnabled={gestorCrossEnabled}
                                    hireCmsKey="maestro"
                                    immHireInformation={immHireInformation}
                                    immHiringProductInformation={immHiringProductInformation}
                                    requestPDFMerge={requestPDFMerge}
                                    contracts={immContracts}
                                />
                            </WebappRender>
                            <ContactCenterRender>
                                <HireCardMaestroStep1
                                    contractName="maestro"
                                    flagBasedFeatures={flagBasedFeatures}
                                    gestorCrossEnabled={gestorCrossEnabled}
                                    handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                    hireCmsKey="maestro"
                                    immHireCardMaestro={immHireCardMaestro}
                                    immHireInformation={immHireInformation}
                                    immHiringProductInformation={immHiringProductInformation}
                                    immPreContractualMail={immPreContractualMail}
                                    immProfileFields={immProfile}
                                    requestProfile={requestProfile}
                                    sendMailParams={sendMailParams}
                                    sendPreContractualMail={sendPreContractualMail}
                                    setTermsAndCondsText={setTermsAndCondsText}
                                    requestPDFMerge={requestPDFMerge}
                                    contracts={immContracts}
                                />
                            </ContactCenterRender>
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            onBackClick={false}
                            position="middle"
                        >
                            <HireCardMaestroStep2
                                accountsIndexesFiltered={this.filterAccounts()}
                                handleAccountChange={handleAccountChange}
                                immAccounts={immAccounts}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immHireCardMaestro={immHireCardMaestro}
                                isInactiveAccountsEnabled={isInactiveAccountsEnabled}
                                setAllAccountsToInactive={setAllAccountsToInactive}
                                contracts={immContracts}
                            />
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            onBackClick={false}
                            position="middle"
                            nextButtonDisabled={isShippingAddressButtonDisabled}
                        >
                            <HireCardMaestroStep3
                                immHireContactData={immHireContactData}
                                immShippingAddressList={immShippingAddressList}
                                setShippingAddress={setShippingAddress}
                            />
                        </WizardStep>
                        <WizardStep
                            addLoadingBehaviour={true}
                            cancelButton={true}
                            immFinalButton={'hireCardMaestro-hire'}
                            isLoading={immHireCardMaestro.get('isFetching')}
                            onBackClick={false}
                            position="last"
                        >
                            <HireCardMaestroStep4
                                immAccounts={immAccounts}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immHireCardMaestro={immHireCardMaestro}
                                immShippingAddress={immShippingAddressList}
                                handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                operativeName={__CONTACT_CENTER__ ? "operatives-Maestro" : undefined}
                                originCountry={immProfile.get('originCountry')}
                                sendPrecontractualDocumentMail={sendPrecontractualDocumentMail}
                                setTermsAndCondsText={setTermsAndCondsText}
                                immPdfData={immPdfData}
                            />
                        </WizardStep>
                    </Wizard>
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                            <HireCardSidebar
                                immAccounts={immAccounts}
                                immAddress={immShippingAddressList.get('shippingAddress')}
                                immHireCardImageSelector={immHireCardImageSelector}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immProfile={immProfile}
                                immShippingAddressList={immShippingAddressList}
                                selectedAccount={immSteps.getIn([SECOND_STEP, 'accountId'])}
                                type="debit"
                                hasShippingAddress={hasShippingAddress}
                            />
                        </div>
                        <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                            <CallMeBack context="contracts" modifier="contracts-view" pageTitle={formatText('breadcrumb-cards')} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { immHireCardMaestro, flagBasedFeatures } = this.props;
        const pageTitle = getFinalTitle('hireCardMaestro-pageTitle');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: formatText("hireCardMaestro-breadcrumb")
            }
        ];
        const isErrorAvailableAccounts = this.filterAccounts().length === 0;

        const processDetail = this.getProcessDetail();
        const hireRestrictionFlag = immHireCardMaestro.getIn(['steps', WIZARD_FIRST_STEP - 1, 'hireRestriction']);
        const hireRestrictionFF = flagBasedFeatures.get(MESSAGE_HIRE_24H);

        let content;

        if (immHireCardMaestro.get('error') || isErrorAvailableAccounts) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCardMaestroError
                        immHireCardMaestro={immHireCardMaestro}
                        isErrorAvailableAccounts={isErrorAvailableAccounts}
                        processDetail={processDetail}
                    />
                </div>
            );
        } else if (hireRestrictionFlag && hireRestrictionFF) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCardMaestroError
                        immHireCardMaestro={immHireCardMaestro}
                        isErrorAvailableAccounts={isErrorAvailableAccounts}
                        processDetail={processDetail}
                        hireRestrictionFlag={hireRestrictionFlag}
                    />
                </div>
            );
        } else if (immHireCardMaestro.get('submitSuccessful')) {
            content = this.buildSuccessful();
        } else if (immHireCardMaestro.get('allAccountsInactive')) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <InactiveAccountsError
                        navigateToBackButtonText={'cards'}
                        navigateToBackButtonURL={'cards'}
                    />
                </div>
            );
        } else {
            content = this.buildWizardHiringSteps();
        }

        return (
            <div className="hire-card-maestro">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={pageTitle}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HireCardMaestroView.propTypes = {
    flagBasedFeatures: PropTypes.object.isRequired,
    getHireCardImages: PropTypes.func.isRequired,
    gestorCrossEnabled: PropTypes.bool,
    handleAccountChange: PropTypes.func.isRequired,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    hireCardMaestro: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardMaestro: PropTypes.object.isRequired,
    immHireContactData: PropTypes.object.isRequired,
    immHireInformation: PropTypes.object.isRequired,
    immHiringProductInformation: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    requestPDFMerge: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    immProfile: PropTypes.object.isRequired,
    immPdfData: PropTypes.object.isRequired,
    immContracts: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    match: PropTypes.object,
    reset: PropTypes.func.isRequired,
    resetPrecontractualDocumentMail: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetTermsAndCondsText: PropTypes.func.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    getshippingAddressList: PropTypes.func,
    immShippingAddressList: PropTypes.object,
    setShippingAddress: PropTypes.func,
};

module.exports.constructor = HireCardMaestroView;
module.exports.HireCardMaestroView = connect(
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
        gestorCrossEnabled: state.flagBasedFeatures.get('web-gc-enabled'),
        immAccounts: state.accounts,
        immCards: state.cards,
        immContracts: state.globalVariables.getIn(['variables', 'parameters', 'contratos']),
        immHireCardImageSelector: state.hireCardImageSelector,
        immHireCardNameSelector: state.hireCardNameSelector,
        immHireCardMaestro: state.hireCardMaestro,
        immHireCreditLimit: state.hireCreditLimit,
        immHireInformation: state.hireInformation,
        immHiringProductInformation: state.hiringProductInformation,
        immHirePaymentMethod: state.hirePaymentMethod,
        immHireContactData: state.hireContactData,
        immPreContractualMail: state.preContractualMail,
        immProfile: state.profile,
        immPdfData: state.precontractualsMergePdfs,
        immShippingAddressList: state.shippingAddress,
        isInactiveAccountsEnabled: state.flagBasedFeatures.get('web-inactive-account-enabled'),
    }),
    {
        getHireCardImages: hireCardImageSelectorActions.getHireCardImages,
        getshippingAddressList: shippingAddressAction.getShippingAddressList,
        handleAccountChange: hireCardMaestroActions.setAccount,
        handleAgreementCheckboxChange: hireCardMaestroActions.setAgreementCheckbox,
        hireCardMaestro: hireCardMaestroActions.hireCardMaestro,
        requestPDFMerge: mergePreContractualsPDF.requestPDFMerge,
        requestProfile: profileActions.requestProfile,
        reset: hireCardMaestroActions.reset,
        resetPrecontractualDocumentMail: precontractualDocumentMailAction.resetPrecontractualDocumentMail,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        resetTermsAndCondsText: termsAndCondsInfoActions.reset,
        sendPrecontractualDocumentMail: precontractualDocumentMailAction.sendPrecontractualDocumentMail,
        sendPreContractualMail: preContractualMailActions.sendPreContractualMail,
        setAllAccountsToInactive: hireCardMaestroActions.setAllAccountsToInactive,
        setShippingAddress: shippingAddressAction.setShippingAddress,
        setTermsAndCondsText: termsAndCondsInfoActions.setTermsAndCondsText,
        setVisibleStep: hireCardMaestroActions.setVisibleStep,
        setWillCancel: hireCardMaestroActions.setWillCancel,
        validateStep: hireCardMaestroActions.validateStep,
    }
)(withRouter(HireCardMaestroView));
